const HOME_TYPES = {
  FETCH_SCHEDULE_DATA_BEGIN: "FETCH_SCHEDULE_DATA_BEGIN",
  FETCH_SCHEDULE_DATA_SUCCESS: "FETCH_SCHEDULE_DATA_SUCCESS",
  FETCH_SCHEDULE_DATA_FAILURE: "FETCH_SCHEDULE_DATA_FAILURE",

  INVITE_USER_BEGIN: "INVITE_USER_BEGIN",
  INVITE_USER_SUCCESS: "INVITE_USER_SUCCESS",
  INVITE_USER_FAILURE: "INVITE_USER_FAILURE",

  SUBMIT_CONTACT_FORM_BEGIN: "SUBMIT_CONTACT_FORM_BEGIN",
  SUBMIT_CONTACT_FORM_SUCCESS: "SUBMIT_CONTACT_FORM_SUCCESS",
  SUBMIT_CONTACT_FORM_FAILURE: "SUBMIT_CONTACT_FORM_FAILURE",

  FETCH_MESSAGES_BEGIN: "FETCH_MESSAGES_BEGIN",
  FETCH_MESSAGES_SUCCESS: "FETCH_MESSAGES_SUCCESS",
  FETCH_MESSAGES_FAILURE: "FETCH_MESSAGES_FAILURE",

  FETCH_NOTIFICATIONS_BEGIN: "FETCH_NOTIFICATIONS_BEGIN",
  FETCH_NOTIFICATIONS_SUCCESS: "FETCH_NOTIFICATIONS_SUCCESS",
  FETCH_NOTIFICATIONS_FAILURE: "FETCH_NOTIFICATIONS_FAILURE",

  FETCH_UNREAD_COUNT_BEGIN: "FETCH_UNREAD_COUNT_BEGIN",
  FETCH_UNREAD_COUNT_SUCCESS: "FETCH_UNREAD_COUNT_SUCCESS",
  FETCH_UNREAD_COUNT_FAILURE: "FETCH_UNREAD_COUNT_FAILURE",

  MARK_NOTIFICATION_READ_BEGIN: "MARK_NOTIFICATION_READ_BEGIN",
  MARK_NOTIFICATION_READ_SUCCESS: "MARK_NOTIFICATION_READ_SUCCESS",
  MARK_NOTIFICATION_READ_FAILURE: "MARK_NOTIFICATION_READ_FAILURE",

  DELETE_NOTIFICATION_BEGIN: "DELETE_NOTIFICATION_BEGIN",
  DELETE_NOTIFICATION_SUCCESS: "DELETE_NOTIFICATION_SUCCESS",
  DELETE_NOTIFICATION_FAILURE: "DELETE_NOTIFICATION_FAILURE",

  FETCH_COMPLETION_BEGIN: "FETCH_COMPLETION_BEGIN",
  FETCH_COMPLETION_SUCCESS: "FETCH_COMPLETION_SUCCESS",
  FETCH_COMPLETION_FAILURE: "FETCH_COMPLETION_FAILURE",

  UPDATE_NOTIFICATION_TOKEN_BEGIN: "UPDATE_NOTIFICATION_TOKEN_BEGIN",
  UPDATE_NOTIFICATION_TOKEN_SUCCESS: "UPDATE_NOTIFICATION_TOKEN_SUCCESS",
  UPDATE_NOTIFICATION_TOKEN_FAILURE: "UPDATE_NOTIFICATION_TOKEN_FAILURE",
};

export default HOME_TYPES;
